import { type GateAccessQrView } from '@m/types/api';
import { apiFetchV2 } from '@m/utils/http';
import { useQuery } from '@tanstack/react-query';

import { getLaneGateAccessQrQueryKey } from './query-keys';
import { adminSiteLaneCustomerInitiatedAccessQr } from './routes';

const getGateAccessQr = ({ siteId, laneId }: { laneId: number; siteId: number }) =>
  apiFetchV2<GateAccessQrView>(adminSiteLaneCustomerInitiatedAccessQr(siteId, laneId));

export const useGateAccessQr = (siteId: number, laneId: number, enabled = true) =>
  useQuery({
    queryKey: getLaneGateAccessQrQueryKey(siteId, laneId),
    queryFn: () => getGateAccessQr({ siteId, laneId }),
    enabled: enabled && !!siteId && !!laneId,
    retry: false,
  });
